import axios from "../axios";
import { IPageListData, IPageListParams, IUseLearnParams } from "./sensorLearn.types";

/**
 * 分页
 */
export function pageList(params: IPageListParams) {
    return axios<IPageListData>({
        method: 'get',
        url: '/sensorLearn/pageList',
        params,
    })
}

/**
 * 使用
 */
export function useLearn(params: IUseLearnParams) {
    return axios({
        method: 'post',
        url: '/sensorLearn/useLearn',
        data: params,
    })
}
